var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "budicon-newspaper") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application_Screening_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lease-Details",
    transform: "translate(-861.000000, -841.000000)",
    fill: "#22212A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-newspaper",
    transform: "translate(861.000000, 841.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,22 L1,20 L1,12.5 C1,12.224 1.224,12 1.5,12 L5,12 L5,20 L5,21.5 L5,22 C5,23.103 4.103,24 3,24 C1.897,24 1,23.103 1,22 L1,22 Z",
    id: "Shape",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,1 L22.779,1 L22.779,19.5 C22.779,21.43 21.209,23 19.279,23 L5.817,23 C5.682,23.371 5.482,23.711 5.222,24 L20.5,24 C22.43,24 24,22.43 24,20.5 L24,1.5 C24,1.224 23.776,1 23.5,1 L23.5,1 Z",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,12 L9.5,12 C9.224,12 9,12.224 9,12.5 C9,12.776 9.224,13 9.5,13 L20.5,13 C20.776,13 21,12.776 21,12.5 C21,12.224 20.776,12 20.5,12 L20.5,12 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,16 L9.5,16 C9.224,16 9,16.224 9,16.5 C9,16.776 9.224,17 9.5,17 L20.5,17 C20.776,17 21,16.776 21,16.5 C21,16.224 20.776,16 20.5,16 L20.5,16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,20 L9.5,20 C9.224,20 9,20.224 9,20.5 C9,20.776 9.224,21 9.5,21 L17.5,21 C17.776,21 18,20.776 18,20.5 C18,20.224 17.776,20 17.5,20 L17.5,20 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,4 L10,4 C9.448,4 9,4.448 9,5 L9,8 C9,8.552 9.448,9 10,9 L20,9 C20.552,9 21,8.552 21,8 L21,5 C21,4.448 20.552,4 20,4 L20,4 Z M20,8 L10,8 L10,5 L20,5 L20,8 L20,8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,0 L6.5,0 C5.673,0 5,0.673 5,1.5 L5,11 L1.5,11 C0.673,11 0,11.673 0,12.5 L0,20 L0,22 C0,23.657 1.343,25 3,25 L20.5,25 C22.981,25 25,22.981 25,20.5 L25,1.5 C25,0.673 24.327,0 23.5,0 L23.5,0 Z M1,22 L1,20 L1,12.5 C1,12.224 1.224,12 1.5,12 L5,12 L5,20 L5,21.5 L5,22 C5,23.103 4.103,24 3,24 C1.897,24 1,23.103 1,22 L1,22 Z M24,20.5 C24,22.43 22.43,24 20.5,24 L5.221,24 C5.7,23.468 6,22.772 6,22 L6,21.5 L6,20 L6,12 L6,11.5 L6,1.5 C6,1.224 6.224,1 6.5,1 L23.5,1 C23.776,1 24,1.224 24,1.5 L24,20.5 L24,20.5 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentPdf);
export default __webpack_public_path__ + "static/media/icon-document-pdf.b001bdcd20e760fdcf9d999899ae659d.svg";
export { ForwardRef as ReactComponent };